











import { Component, Vue } from 'vue-property-decorator'

import Footer from '@/components/Footer.vue'
import UnauthenticatedLayoutHeader from '@/components/UnauthenticatedLayoutHeader.vue'

import EventBus from '@/event-bus'

@Component({
  components: {
    UnauthenticatedLayoutHeader,
    Footer,
  },
})
export default class UnauthenticatedLayout extends Vue {
  customStyle: any = {}

  created() {
    EventBus.$on(
      'set-layout-background',
      (background: { backgroundImage: string }) => {
        this.customStyle = { ...this.customStyle, ...background }
      },
    )
  }

  mounted() {
    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === 'logined' && event.newValue === 'true') {
        window.location.reload()
      }
    })
  }
}
